export const GET_ALL_EVENT = 'get_all_event'
export const EVENT_ERROR = 'event_error'
export const GET_EVENT_DETAILS = 'event_details'
export const GET_SEEKAR_EVENTS = 'get_all_seekar_event'
